const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1399.48 115.481v-4.399a.76.76 0 0 1 1.52 0v4.842c0 .055-.02.105-.03.157.01.053.03.103.03.158 0 .42-.34.76-.76.76h-18.48a.76.76 0 0 1-.76-.76c0-.055.02-.105.03-.158-.01-.052-.03-.102-.03-.158v-4.841a.76.76 0 0 1 1.52 0v4.399h16.96Zm-8.43-16.48a.76.76 0 0 0-.76.759v11.087l-3.32-3.305a.766.766 0 0 0-1.08 0c-.3.296-.3.776 0 1.073l4.62 4.601c.15.148.34.222.54.222.19 0 .39-.074.54-.222l4.62-4.601a.77.77 0 0 0 0-1.073.766.766 0 0 0-1.08 0l-3.32 3.305V99.76a.76.76 0 0 0-.76-.759Z",
    style: {
      fill: "#727272"
    },
    transform: "translate(-1381 -98)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic-download.5401dd1b70215ebc6fe3f51606d4ef63.svg";
export { ForwardRef as ReactComponent };